import api from "../api";
import { mapToColumnModel } from "./mappers";
import { ChannelType, CompanyType, EConsentDetailsModel, StatusType } from "./types";

interface TypeParams {
  type: StatusType;
  channel: ChannelType;
  company: CompanyType;
  isDelegateToMe: boolean;
  from?: string;
  to?: string;
  hn?: string;
}

const EconsentDetails = async (params: TypeParams): Promise<EConsentDetailsModel[]> => {
  const { type } = params;
  if (type === StatusType.UNDEFINED) return [];

  const res = await api.get<EConsentDetailsModel[]>(
    `${process.env.REACT_APP_ECONSENT_SUFFIX}/econsent/details`,
    { params }
  )

  return res.data;
}

export const fetchData = async (type: StatusType, channel: ChannelType, company: CompanyType, isDelegateToMe: boolean, from?: string, to?: string, hn?: string) => {
  const transactions = await EconsentDetails({ type, channel, company, isDelegateToMe, from, to, hn });

  const sortedTransactions = [...transactions].sort((a, b) => {
    const date1: number = Number(new Date(a.appointmentDateTime ?? 0));
    const date2: number = Number(new Date(b.appointmentDateTime ?? 0));
    return date2 - date1;
  });
  return mapToColumnModel(sortedTransactions);
}

export const fetchDataPending = async (channel: ChannelType, company: CompanyType, isDelegateToMe: boolean, from: string, to: string, hn: string) => {
  const params = { channel, company, isDelegateToMe, from, to, hn };

  const pendingCreated = await EconsentDetails({ type: StatusType.PENDING_TO_CREATE_TRANSACTION, ...params });
  const pendingPatient = await EconsentDetails({ type: StatusType.PENDING_PATIENT, ...params });
  let all = pendingCreated.concat(pendingPatient);
  all = [...all].sort((a, b) => {
    const date1: number = Number(new Date(a.appointmentDateTime ?? 0));
    const date2: number = Number(new Date(b.appointmentDateTime ?? 0));
    return date2 - date1;
  });
  return mapToColumnModel(all)
}

export const fetchDataAll = async (channel: ChannelType, company: CompanyType, isDelegateToMe: boolean, from?: string, to?: string, hn?: string) => {
  const params = { channel, company, isDelegateToMe, from, to, hn };

  const pendingCreated = await EconsentDetails({ type: StatusType.PENDING_TO_CREATE_TRANSACTION, ...params });
  const pendingPatient = await EconsentDetails({ type: StatusType.PENDING_PATIENT, ...params });
  const pendingWitness = await EconsentDetails({ type: StatusType.PENDING_WITNESS, ...params });
  const completed = await EconsentDetails({ type: StatusType.COMPLETED, ...params });
  const cancelled = await EconsentDetails({ type: StatusType.CANCELLED, ...params });
  const declined = await EconsentDetails({ type: StatusType.DECLINED, ...params });
  const expired = await EconsentDetails({ type: StatusType.EXPIRED, ...params });

  let all = pendingCreated.concat(pendingPatient, pendingWitness, completed, cancelled, declined, expired);
  all = [...all].sort((a, b) => {
    const date1: number = Number(new Date(a.appointmentDateTime ?? 0));
    const date2: number = Number(new Date(b.appointmentDateTime ?? 0));
    return date2 - date1;
  });
  return mapToColumnModel(all)
};

export const fetchDataCancelled = async (channel: ChannelType, company: CompanyType, isDelegateToMe: boolean, from?: string, to?: string, hn?: string) => {
  const params = { channel, company, isDelegateToMe, from, to, hn };
  const cancelled = await EconsentDetails({ type: StatusType.CANCELLED, ...params });
  const declined = await EconsentDetails({ type: StatusType.DECLINED, ...params });
  const expired = await EconsentDetails({ type: StatusType.EXPIRED, ...params });
  let all = cancelled.concat(declined, expired);
  all = [...all].sort((a, b) => {
    const date1: number = Number(new Date(a.appointmentDateTime ?? 0));
    const date2: number = Number(new Date(b.appointmentDateTime ?? 0));
    return date2 - date1;
  });
  return mapToColumnModel(all)
}